const operationMessages = new Map([
  ['消息已撤回', '消息已撤回'],
  ['请使用有会话权限的客服账号', '你暂时无法执行此操作，请联系管理员。'],
  ['不支持此操作', '此消息暂不支持此操作。'],
  ['请求标识无效', '操作未能提交，请刷新页面后再试。'],
  ['消息不属于 WhatsApp', '此消息暂不支持此操作。'],
  ['只能编辑发送后 15 分钟内的纯文字消息', '只能编辑发送后 15 分钟内的纯文字消息'],
  ['表情无效', '请选择有效的表情。'],
  ['此消息不能从 Borderchat 撤回', '此消息暂不支持撤回。'],
  ['暂时无法确认此消息的发送结果，未执行撤回，请联系管理员核查。', '暂时无法确认此消息的发送结果，未执行撤回，请联系管理员核查。'],
  ['请先核对投递状态，未重发', '请先核对发送结果，本次未重新发送。'],
  ['渠道回调地址无效', '操作暂时不可用，请联系管理员核查。'],
  ['操作标识冲突', '未取得明确结果，请刷新详情核对，请勿重复发送。'],
  ['上一项操作仍在等待渠道确认，请先核对', '上一项操作结果尚未确认，请先核对，请勿重复发送。'],
]);

export const operationFeedback = value => operationMessages.get(value) || '未取得明确结果，请刷新详情核对，请勿重复发送。';

export function orderFeedback(order = {}) {
  if (order.sync_status === 'not_found') return '暂未找到该订单，请确认订单号。';
  if (['pending', 'syncing'].includes(order.sync_status)) return '订单信息正在更新，请稍后查看。';
  return '订单信息暂时无法更新，请联系管理员核查。';
}

export function orderRequestFeedback(action, status) {
  if (status === 429) return '操作过于频繁，请稍候再试。';
  if (status === 403) return '你暂时无法执行此操作，请联系管理员。';
  if (action === 'unlink') return '解绑未成功，请刷新后确认关联状态。';
  return '订单信息暂时无法获取，请稍后重试；如持续异常，请联系管理员。';
}
